import request from '@/utils/request'

export function pageObjectives(pageNum, pageSize, courseId, title) {
  return request({
    url: '/amc/course-objective/paging',
    method: 'get',
    params: { pageNum, pageSize, courseId, title }
  })
}

export function pageNewObjectives(pageNum, pageSize, courseId) {
  return request({
    url: '/amc/course-objective/new',
    method: 'get',
    params: { pageNum, pageSize, courseId }
  })
}

export function createObjective(data) {
  return request({
    url: '/amc/course-objective',
    method: 'post',
    data
  })
}

export function updateObjective(id, data) {
  return request({
    url: `/amc/course-objective/${id}`,
    method: 'put',
    data
  })
}

export function deleteObjective(id) {
  return request({
    url: `/amc/course-objective/${id}`,
    method: 'delete'
  })
}
